import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-31e0bf36"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, null, -1));

const _hoisted_6 = {
  class: "icon-word"
};
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Android下载 ");

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "beian"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("网站备案/许可证号："), /*#__PURE__*/_createElementVNode("a", {
  class: "beian-link",
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "beian-color"
}, "粤ICP备2022113931号-1")])])], -1));

const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "tips-val"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("点击右上角使用");

const _hoisted_13 = ["src"];

const _hoisted_14 = /*#__PURE__*/_createTextVNode("选择\"浏览器中打开\"");

const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.down_back,
    class: "down-back-top"
  }, null, 8, _hoisted_2), _createElementVNode("img", {
    src: $setup.down_c,
    class: "down-back"
  }, null, 8, _hoisted_3), _createElementVNode("img", {
    src: $setup.icon,
    class: "app-icon"
  }, null, 8, _hoisted_4), _hoisted_5, _createElementVNode("div", {
    class: "down-btn btn-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $setup.android,
    class: "down-icon"
  }, null, 8, _hoisted_7)]), _hoisted_8]), _hoisted_9]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_hoisted_12, _createElementVNode("img", {
    src: $setup.ponits,
    class: "safari"
  }, null, 8, _hoisted_13)]), _createElementVNode("div", null, [_hoisted_14, _createElementVNode("img", {
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_15)])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : _createCommentVNode("", true)]);
}